<script setup lang="ts">
import { IconFont } from '../../IconFont'

const props = withDefaults(defineProps<{
  value?: number
}>(), {
  value: undefined,
})

defineOptions({
  name: 'NumericalTrend',
})
</script>

<template>
  <span
    class=" inline-flex items-center px-1 py-1 leading-none rounded-md text-xs" :class="{
      'bg-[#FFEDED] text-error': props.value > 0,
      'bg-[rgba(79,204,122,0.10)] text-success': props.value < 0,
      'bg-n-40': props.value === 0,
    }"
  >
    <template v-if="props.value === undefined">--</template>
    <template v-else-if="!Boolean(props.value)">持平</template>
    <template v-else> {{ (props.value * 100).toFixed(2) }}%</template>

    <IconFont v-if="props.value < 0" type="icon-jiantou-xiadie-xiao" class="leading-none -translate-y-[1px]" />
    <IconFont v-else-if="props.value > 0" type="icon-jiantou-shangzhang-xiao" class="leading-none -translate-y-[2px]" />
  </span>
</template>
